import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import Loading from '@components/Loading';

const LoadingPage: React.FC<IProps> = (props) => {

  return (
    <S.Root style={props.containerStyles}>
      <S.LoadingContainer style={props.styles}>
        <Loading containerStyle={{justifyContent: 'center'}} />
      </S.LoadingContainer>
    </S.Root>
  );
}

export default LoadingPage;